import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";

import {getData} from '../../../services/index';
import { Tabs ,Modal} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';
import { message,Menu,Button } from 'antd';
import { MailOutlined, AppstoreOutlined, SettingOutlined,DeleteOutlined } from '@ant-design/icons';
import Pagination from "react-js-pagination";
import { PlusOutlined,MoreOutlined,FieldTimeOutlined,EditOutlined } from '@ant-design/icons';


import next from '../../../assets/images/icon/next.png';
import add from '../../../assets/images/icon/add.png';


const { SubMenu } = Menu;
const { TabPane } = Tabs;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			visible: false,
			route_list: [],
			page: 1,
			total_count: 0,
			name : '',
			academic_year_: [],
			program_list: [],
			data_list: [],
			academic_year: '',
			program_id: '',
			route_type: '',
			route_id: '',
		}
		this.onChangePage = this.onChangePage.bind(this);
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.openQuantity = this.openQuantity.bind(this);
		this.change_year = this.change_year.bind(this);
	}

	change_year(event){
		this.setState({academic_year: event.target.value});
	}

	openQuantity(e){
		this.setState({ program_id: e.target.value });
	}

	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};

	onChangePage=(pageNumber)=>{
	    this.setState({ page : pageNumber });
	    setTimeout(() => {
		 this.checkData();
	    }, 500);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		this.setState({ route_id : this.props.match.params.id,route_type : this.props.match.params.text });
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			this.checkData();
		}

	}

	handleSubmit(e){
		setTimeout(() => {
			this.setState({ page: 1 });
			this.checkData();
		}, 50);
	}


	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var app = {school_id:school_id,user_id:user_id,route_id:this.props.match.params.id,type:this.props.match.params.text}
			getData('Transport/check_route_list_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							data_list: result['data'],
							route_list: result['data'][0]['stop'],
						});
					}else{
						this.setState({
							route_list: [],
							total_count:0
						});
					}
				}
			});
		}
	}

	showModal = () => {
		this.setState({
		  visible: true,
		});
	  };

	  handleOk = () => {
		this.setState({ loading: true });
		setTimeout(() => {
		  this.setState({ loading: false, visible: false });
		}, 3000);
	  };

	  handleCancel = () => {
		this.setState({ visible: false });
	  };



	showMenu= (id, e) =>  {
		e.preventDefault();
		if(this.state.showMenu == 1){
			document.getElementById('open_action_' + id).classList.remove('is-active');
			this.setState({
			  showMenu: 0,
			});
		}else{
			document.getElementById('open_action_' + id).classList.add('is-active');
			this.setState({
			  showMenu: 1,
			});
		}


	}

	handledelete=(e,a)=>{
		var app = {
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			id : e,
		}
		getData('Transport/assign_student_delete',app).then((result) => {
			if(result.status==200){
				message.config({ top: 150});
				message.success('Deleted Successfull',2);
				setTimeout(() => {
					this.checkData()
				}, 30);
			}
		});
	}

	showAction = (index) => {
		if (this.state.selected_child.length == 0) {
		  if (index == this.state.is_open) {
			this.setState({ is_open: -1 });
		  } else {
			this.setState({ is_open: index });
		  }
		} else {
		  if (this.state.is_trip_started < 2) {
			alert("Please Pick Up Selected Children");
		  } else {
			this.setState({ is_open: index });
		  }
		}
	};

	render() {
	const { current } = this.state;
	const { visible, loading } = this.state;
		return (
		<>

		<div class="row bred">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<h4 class="page-title">
							<i class="mdi mdi-apple-keyboard-command title_icon"></i>Route Details

							<div class="breadcrumb-wrapper">
								<ol class="breadcrumb">
									<li class="breadcrumb-item">
										<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
										<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
										</a>
									</li>
									<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/transport-setup/check-route`} class="router-link-active" target="_self">Route Details</a> </li>
									<li class="breadcrumb-item"> {this.state.route_type} </li>
								</ol>
							</div>
						</h4>
					</div>
				</div>
			</div>
		</div>

			<div class="row">
          <div class="col-lg-12 mb-3">
            <div class="card">
              <div class="card-body">
                <div class="row" style={{'align-items': 'baseline'}}>
					<div class="col-lg-5 col-md-5 col-xs-12">
						{this.state.data_list.map((list, index) => (
						<>
						<div class="col-md-12">
							<h5>Route Name : <b>{list.name}</b></h5>
						</div>
						<div class="col-md-12 mt-20">
							<h5>Route Type : <b>{list.tag}</b></h5>
						</div>
						<div class="col-md-12 mt-20">
							<h5>Bus : <b>{list.bus_name}</b></h5>
						</div>
						<div class="col-md-12 mt-20">
							<h5>Driver : <b>{list.driver_name} - {list.driver_mobile}</b></h5>
						</div>
						<div class="col-md-12 mt-20">
							<h5>Stop : {list.stop.map((stp) => (
									<>
										<li class="mt-10">{stp.stop_name}</li>
									</>
									))}	</h5>
						</div>
						</>
						))}
					</div>
                  <div class="col-lg-7 col-md-7 col-xs-12">
                    <div className="innerContainer">
                      {this.state.route_list.map((item, index) => (
                        <>

                                  <div
                                    className="stepBox"
                                    onPress={() => this.showAction(index)}
                                  >
                                    <div className="stepIconView" style={{'height': '40px'}}>

									<img
									  src="/assets/images/process1.png"
									  className="activeCircle"
									/>

								    <div className="verticalLine">
									<img
									  src="/assets/images/line.png"
									  className="svgLine"
									/>
								    </div>
                                    </div>

                                    <div onPress={() => this.showAction(index)}>
                                      <div className="routeDetails">
                                        <div className="circle">
                                          <h1 className="routeNumber">
                                            {index + 1}
                                          </h1>
                                        </div>
                                        <div className="routeView">
                                          <h1 className="routeName">
                                            {item.stop_name}
                                          </h1>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div
                                    className="stepBox"
                                    collapsed={
                                      index == this.state.is_open ? false : true
                                    }
                                  >
                                    <div className="verticalView">
                                      <div className="verticalLine">
                                        <img
                                          src="/assets/images/line.png"
                                          className="svgLine"
                                        />
                                      </div>
                                    </div>



                                    <div className="route-right" style={{'margin-bottom': '25px'}}>
                                      <div className="mainView">
                                        <h1 className="scheduledText">
                                          Time: {item.time}
                                        </h1>
                                      </div>

                                      <div className="childProfile">
                                        {item.student.map(
                                          (student, index) => (
                                            <div className="childList">
                                              <div className="imgBox">
                                                <img
                                                  src={student.image}
                                                  className="childImg"
                                                />
                                              </div>
                                              <div className="infoBox">
                                                <h1 className="childName">
                                                  {student.name}
                                                </h1>
                                                <h1 className="className">
                                                  {student.class}
                                                </h1>
                                              </div>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  </div>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </>
		)
	}
}
export default Index;
